import { useChangeClientTypeMutation, useProfileAccountsQuery } from "../../api/profileApi";
import { useCallback, useMemo } from "react";
import { openSnackbarError } from "../../utils/NotificationsUtils";
import { accountTypeSelector, setAccountType } from "../../slices/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import { getErrorTextFromError } from "../../utils";
import { useCurrentAccount } from "./useCurrentAccount";

export const useAccountsProfile = () => {
  const { data, isLoading } = useProfileAccountsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [changeClientTypeMutation, changeClientTypeData] = useChangeClientTypeMutation();
  const dispatch = useDispatch();
  const accountType = useSelector(accountTypeSelector);
  const currentAccount = useCurrentAccount();
  const listAccounts = useMemo(() => {
    return (data?.data as Auth.AvailableAccountTypes[]) ?? [];
  }, [data?.data]);

  const listAccountsForChange = useMemo(() => {
    if (accountType?.id === undefined) return listAccounts;
    return listAccounts.filter((account) => account.id !== accountType.id);
  }, [accountType?.id, listAccounts]);

  const hasOtherAccounts = useMemo(() => {
    return listAccounts.length > 1;
  }, [listAccounts.length]);

  const changeAccount = useCallback((account: Auth.AvailableAccountTypes) => {
    try {
      return changeClientTypeMutation({ accountId: account.id })
        .unwrap()
        .then((res) => {
          dispatch(setAccountType(account));
          return res;
        });
    } catch (error) {
      const errorText = getErrorTextFromError(error);
      openSnackbarError(error);
      throw new Error(errorText, undefined);
    }
  }, []);

  return {
    changeAccount,
    listAccounts,
    hasOtherAccounts,
    listAccountsForChange,
    changeClientTypeDataLoading: changeClientTypeData.isLoading,
    listAccountsLoading: isLoading,
    currentAccount: currentAccount,
  };
};
